/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Automations from './Automations/index'
import BackAction from './BackAction/index'
import Connections from './Connections/index'
import Description from './Description/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import InitialRedirect from './InitialRedirect/index'
import LearnMore from './LearnMore/index'
import LearnMoreAction from './LearnMoreAction/index'
import Link from './Link/index'
import Logo from './Logo/index'
import Name from './Name/index'
import Properties from './Properties/index'
import React from 'react'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import UninstallAction from './UninstallAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content"
  
}) {
let tabSelectedAppIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.app_id',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
 data="tab.selected.app_id"
 appId={tabSelectedAppIdValueData}
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Logo
  viewPath={`${viewPath}/Logo`}
/>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--ml-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<Link
  viewPath={`${viewPath}/Link`}
/>
</div>
</div>
<UninstallAction
  viewPath={`${viewPath}/UninstallAction`}
/>
<Properties
  viewPath={`${viewPath}/Properties`}
/>
<BackAction
  viewPath={`${viewPath}/BackAction`}
/>
</div>
</div>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical3}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceM}
 marginBottom={dtSpaceL}
/>
<div
  data-testid="Content.Vertical:4"
  data-view-path={viewPath}
 style={{'--pl-2-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pb-5-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical4}`}
>
<Description
  viewPath={`${viewPath}/Description`}
/>
<LearnMoreAction
  viewPath={`${viewPath}/LearnMoreAction`}
/>
<LearnMore
  viewPath={`${viewPath}/LearnMore`}
/>
<Connections
  viewPath={`${viewPath}/Connections`}
/>
<Automations
  viewPath={`${viewPath}/Automations`}
/>
</div>
</div>
</div>
<InitialRedirect
  viewPath={`${viewPath}/InitialRedirect`}
/>
{children}
</React.Fragment>)
}